var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHowitworks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1214,
    height: 597,
    viewBox: "0 0 1214 597",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1214,
    height: 597,
    rx: 32,
    fill: "#F8FBFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHowitworks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/howitworks.2fd04a0c7cc41e5d6f8d8137b04f6db1.svg";